<ng-template #cartBtn let-isSticky="isSticky">
  <div class="d-flex justify-content-end my-2">
    <cart-btn-quantity-price
      class="d-block mr-075"
    ></cart-btn-quantity-price>

    <button class="btn ws-button ws-button--primary checkout-btn uppercase"
            [translate]="'orderProcess.cakesOverview.goToCheckout'"
            (click)="onContinue.emit()">
      Go to checkout
    </button>
  </div>
  @if (!ui.isSm()) {
    <div class="cart-wrap">
      <ng-content></ng-content>
    </div>
  }
</ng-template>


@if (!isStick) {
  <div class="position-relative">
    <ng-container *ngTemplateOutlet="cartBtn;context:{isSticky:false}"></ng-container>
  </div>
}

<div class="show-cart-and-checkout-wrap-fixed ws-cart-bar" #bar
     [class.ms-4]="!isStick"
     [class.stick]="isStick"
     stick
     [extraOffset]="extraOffset"
     (onStick)="setStick($event)">
  @if (isStick) {
    <div class="container position-relative">
      <ng-container *ngTemplateOutlet="cartBtn;context:{isSticky:true}"></ng-container>
    </div>
  }
</div>
